import React, { useState } from 'react';
import styles from './MyFollowing.module.css';
import { User, Search } from 'lucide-react';
import useAuthStore from '../../../store/authStore';
import { useFollowers } from '../../../hooks/useFollowersHooks';

const MyFollowing = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const { user } = useAuthStore();

  // Get following list using the custom hook
  const { data: followingData, isLoading, isError } = useFollowers(user?.id);

  // Extract followers list from API response
  const followedAuthors = followingData?.followers || [];

  // Filter authors based on search term
  const filteredAuthors = followedAuthors.filter(author =>
    author.author_name?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  if (isLoading) {
    return <div className={styles.loading}>Loading...</div>;
  }

  if (isError) {
    return <div className={styles.error}>Failed to load authors. Please try again.</div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.profileSection}>
        <div className={styles.profilePicture}>
          <div className={styles.userIcon}>
            <User size={40} color="white" />
          </div>
        </div>
        <h2 className={styles.profileName}>{user?.name}</h2>

        <div className={styles.searchBar}>
          <input
            type="text"
            placeholder="Search authors..."
            className={styles.searchInput}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <button className={styles.searchButton}>
            <Search color="white" />
          </button>
        </div>

        <div className={styles.authorGrid}>
          {filteredAuthors.length > 0 ? (
            filteredAuthors.map(author => (
              <div key={author.id} className={styles.authorCard}>
                <div className={styles.authorImg}>
                  <img src={author.profile_image} alt={author.author_name} />
                </div>
                <p className={styles.authorName}>{author.author_name}</p>
                <button className={styles.unfollowButton}>Followed</button>
              </div>
            ))
          ) : (
            <p className={styles.noResults}>No authors found matching </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyFollowing;
